import { Component, OnInit } from '@angular/core';
import { SessionStorageService } from '../shared/services/session-storage.service';

@Component({
    selector: 'pme-disconnected-sale',
    templateUrl: './disconnected-sale.component.html',
    styleUrls: ['./disconnected-sale.component.scss'],
    standalone: false
})
export class DisconnectedSaleComponent implements OnInit {

  constructor(
  ) { 
  }

  ngOnInit(): void {
  }

}
